import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { PostHogProvider } from 'posthog-js/react'

Bugsnag.start({
  apiKey: '91ce8c22ce1b677ec86cb39d29dd6773',
  plugins: [new BugsnagPluginReact()]
})
BugsnagPerformance.start({ apiKey: '91ce8c22ce1b677ec86cb39d29dd6773' })
const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <PostHogProvider
        apiKey={"phc_flNVV9DvKEuLkdVN4ipGRZFn0BSx5koB50O81GyD2K3"}
        options={{
          api_host: "https://us.i.posthog.com",
          defaults: '2025-05-24',
          capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <App />
      </PostHogProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();